import { cartAtom } from "@/atoms"
import { tableAtom } from "@/atoms/table"
import { useBrowsingChannelCatalog } from "@/hooks/use-browsing-channel-catalog"
import { useAtomValue } from "jotai"
import { couponSnapshotAtom, planDiscounts, rulePromotionSnapshotAtom, type DiscountPlan } from "../lib/discount-plan"
import { checkoutAtom } from "../state"

/** The checkout's discount plan for the bag on screen: what to ask the server and the pricing its answers give. */
export function useDiscountPlan(): DiscountPlan {
  const state = useAtomValue(checkoutAtom)
  const cart = useAtomValue(cartAtom)
  const { categories } = useBrowsingChannelCatalog()
  const rulePromotions = useAtomValue(rulePromotionSnapshotAtom)
  const coupons = useAtomValue(couponSnapshotAtom)
  const isTableOrder = useAtomValue(tableAtom) !== null
  return planDiscounts(state, cart, categories, { rulePromotions, coupons }, { evaluate: !isTableOrder })
}
